// extracted by mini-css-extract-plugin
export default {"content":"XMse4yq4PZ","text":"Jzumd4fI5j"};